module.exports = __webpack_public_path__ + "static/img/gsdt-ban.8d1ca91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gsdt-ban.jpg
// module id = GKct
// module chunks = 1